export const kDITOWUtilsWrapper = 'OWUtilsWrapper';
export const kDITOWGamesWrapper = 'OWGamesWrapper';
export const kDITOWTrackRSWrapper = 'OWTrackRSWrapper';
export const kDITOWSettingsWrapper = 'OWSettingsWrapper';
export const kDITOWGameListenerWrapper = 'OWGameListenerWrapper';
export const kDITOWExtensionWrapper = 'OWExtensionWrapper';
export const kDITOWWrapper = 'OWWrapper';
export const kDITOWCustomURLWrapper = 'OWCustomURLWrapper';
export const kDITokenExternalService = 'ExternalService';
export const kDIOWIOPathsWrapper = 'OWIOPathsWrapper';
export const kDIOWSettingsWrapper = 'OWENotificationSettingsWrapper';
export const kDIOWOWSettingsGamesWrapper = 'OWSettingsGamesWrapper';
export const kDIConfigurations = 'configurations';
export const kDITokenOwNotificationWindow = 'ow-notification-window';
export const kDITokenNotificationWindowScreenAnchor =
  'ow-notification-window-screen-anchor';

export const kDITGameEventsListener = 'OWGameEventsListener';

export const kDITokenWindowListener = 'ow-window-listener';
export const kDITokenLogger = 'Logger';
